export default "__VITE_ASSET__oLDEFQLE__"